// ============================================================================
// CHANGO V5.0 — Frontend capability-layer helpers
// ============================================================================
// Mirrors backend SKU layers:
//   A = factory/manufacturing, B = foreign trade, C = cross-border, E = entity.
// This is UI affordance only; backend layerGuard remains authoritative.
// ============================================================================

const VALID_LAYERS = new Set(['A', 'B', 'C', 'E']);

function parseLayers(raw) {
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== 'string' || raw.trim() === '') return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function normalizeLayers(workspaceOrLayers) {
  const raw = Array.isArray(workspaceOrLayers)
    ? workspaceOrLayers
    : workspaceOrLayers?.enabled_layers;
  return [...new Set(parseLayers(raw)
    .map((layer) => String(layer || '').toUpperCase())
    .filter((layer) => VALID_LAYERS.has(layer)))]
    .sort();
}

export function hasWorkspaceLayer(workspaceOrLayers, layer) {
  const wanted = String(layer || '').toUpperCase();
  if (!VALID_LAYERS.has(wanted)) return false;
  return normalizeLayers(workspaceOrLayers).includes(wanted);
}

export function hasAnyWorkspaceLayer(workspaceOrLayers, layers) {
  if (!Array.isArray(layers)) return false;
  return layers.some((layer) => hasWorkspaceLayer(workspaceOrLayers, layer));
}

export default {
  normalizeLayers,
  hasWorkspaceLayer,
  hasAnyWorkspaceLayer
};
